import * as React from 'react';
import { connect } from 'react-redux';
import { EditorState, convertFromRaw } from 'draft-js';

import NotifyHOC from '../../../../../HOC/Notifications';

import { IApplicationState } from '../../../../../reducers';

import {
    OptionBox,
    OptionBoxWrapper,
    OptionGroupElement
} from '../../../../common/optionBox';
import Toggle from '../../../../common/Toggle';
import { QuestionTypesMap } from '@nexxt/common/questionTypes';
import { splitPathname, getFilteredOption } from '../../../../../utils/string';
import { QTYPES, QuestionSummary } from '@nexxt/common/types';
import { flattenQuestionSummary } from '../../../../../utils/question';

export interface IPipeOptionProps {
    handlePipeOptionFields: (data: Array<any>) => void;
    notify: (
        msg: string,
        type: string,
        options?: Record<string, unknown>,
        callback?: () => unknown
    ) => any;
    options: any;
    question: any;
    currentProject: any;
    showRandomize: boolean;
    questionSummaries: QuestionSummary[];
}

type IOptionFields = IForm;

interface IForm {
    label: string;
    texts: Array<any>;
    value: number;
    mediaURL: string;
}

interface IPipeOptionState {
    currentIndex: number;
    optionFields: any;
}

class PipeOption extends React.Component<IPipeOptionProps, IPipeOptionState> {
    constructor(props) {
        super(props);

        this.state = {
            currentIndex: null,
            optionFields: props.question.pipingQuestions
        };
    }

    onOptionCreationCompleted = (evt) => {
        evt.preventDefault();
    };

    handleRemoveOptionField = (index) => {
        if (index >= 0) {
            const optionFields = [
                ...(this.props.question.pipingQuestions || [])
            ];

            optionFields.splice(index, 1);
            this.props.handlePipeOptionFields(optionFields);
        }
    };

    handleToggleValueChange = (index, keyName, value) => {
        const optionFields = [...(this.props.question.pipingQuestions || [])];
        const newOptionField = optionFields.map((field, sindex) => {
            if (index !== sindex) return field;
            return { ...field, [keyName]: value };
        });
        this.props.handlePipeOptionFields(newOptionField);
    };

    render() {
        const { currentProject, questionSummaries } = this.props;
        const language = currentProject.languages[0];
        const newPipeOptions = getFilteredOption(
            this.props.question.pipingQuestions,
            flattenQuestionSummary(questionSummaries)
        );
        return (
            <React.Fragment>
                <form onSubmit={this.onOptionCreationCompleted}>
                    {newPipeOptions.map((field, index) => {
                        const questionTexts = field.questionTexts || [];
                        const questionTextsObject = {};
                        questionTexts.forEach((q, index) => {
                            questionTextsObject[q.language] = q;
                        });
                        const currentQuestionText =
                            questionTextsObject[language.value] || {};
                        let text = '';
                        if (currentQuestionText.richTexts) {
                            const editorState = EditorState.createWithContent(
                                convertFromRaw(currentQuestionText.richTexts[0])
                            );
                            text =
                                editorState
                                    .getCurrentContent()
                                    .getPlainText() || '';
                        }
                        const qtypeForImage = [
                            QTYPES.POPUP_CARD,
                            QTYPES.MULTI_POPUP_CARD
                        ].includes(field.type)
                            ? QTYPES.POPUP
                            : field.type;
                        return (
                            <OptionBox key={index + field.id}>
                                <div
                                    className="option-box--close"
                                    onClick={() =>
                                        this.handleRemoveOptionField(index)
                                    }
                                >
                                    <i className="nx nx-close" />
                                </div>
                                <div className="option-box--image-box">
                                    <img
                                        src={
                                            (
                                                QuestionTypesMap[
                                                    qtypeForImage
                                                ] || {}
                                            ).image
                                        }
                                    />
                                </div>

                                <OptionBoxWrapper>
                                    <OptionGroupElement label="Question type">
                                        <input
                                            type="text"
                                            // placeholder={`Option label ${index}`}
                                            value={field.type}
                                            className="form-group__control"
                                            name="type"
                                            required
                                            disabled={true}
                                        />
                                    </OptionGroupElement>
                                    <OptionGroupElement label="Question label">
                                        <input
                                            type="text"
                                            // placeholder={`${index}`}
                                            value={field.label}
                                            className="form-group__control"
                                            name="label"
                                            required
                                            disabled={true}
                                        />
                                    </OptionGroupElement>
                                    <OptionGroupElement label="Question text">
                                        <input
                                            type="text"
                                            // placeholder={`${index}`}
                                            value={text}
                                            className="form-group__control"
                                            name="title"
                                            required
                                            disabled={true}
                                        />
                                    </OptionGroupElement>
                                    <OptionGroupElement label="Piping unselected options">
                                        <Toggle
                                            onChange={(value) =>
                                                this.handleToggleValueChange(
                                                    index,
                                                    'reversePiping',
                                                    value
                                                )
                                            }
                                            checked={field.reversePiping}
                                        />
                                    </OptionGroupElement>
                                </OptionBoxWrapper>
                            </OptionBox>
                        );
                    })}
                </form>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject },
        questionReducer,
        router
    } = store;
    const projectId = splitPathname(router.location.pathname);

    return {
        currentProject,
        questionSummaries: questionReducer.questionSummaries[projectId] || []
    };
};

export default NotifyHOC(connect(mapStateToProps, null)(PipeOption));
